import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EmailVerificationModal from './EmailVerificationModal';

const ConsultantGuard = ({ children, requireEmailVerification = false }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkRequirements();
  }, [user, location.pathname]);

  const checkRequirements = async () => {
    if (!user || user.role !== 'consultant') {
      setLoading(false);
      return;
    }

    // Check email verification
    if (requireEmailVerification && !user.isEmailVerified) {
      setShowEmailModal(true);
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  const handleEmailVerified = () => {
    setShowEmailModal(false);
    // Update user in context
    const updatedUser = { ...user, isEmailVerified: true };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    window.location.reload(); // Reload to update context
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh'
      }}>
        <div className="spinner-large"></div>
      </div>
    );
  }

  // Show email verification modal - block access to page
  if (showEmailModal && requireEmailVerification && !user.isEmailVerified) {
    return (
      <div className="consultant-page">
        <div className="verification-required-container">
          <EmailVerificationModal
            isOpen={showEmailModal}
            onClose={() => navigate('/consultant/dashboard')}
            onVerified={handleEmailVerified}
          />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ConsultantGuard;
